import { useSidebar } from '@/core/hooks/useSidebar';
import { cn } from '@/core/lib/utils';

export function SidebarOverlay() {
  const { isMobileOpen, closeMobile } = useSidebar();

  return (
    <div
      aria-hidden="true"
      onClick={closeMobile}
      className={cn(
        'fixed inset-0 bg-black/40 z-30 md:hidden transition-opacity duration-300',
        isMobileOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none',
      )}
    />
  );
}
